(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('PricingDeleteController',PricingDeleteController);

    PricingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pricing'];

    function PricingDeleteController($uibModalInstance, entity, Pricing) {
        var vm = this;

        vm.pricing = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pricing.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
